export default "__VITE_PUBLIC_ASSET__2bef6449__"